import PropTypes from "prop-types"
import TotalEmployeesShape from "./TotalEmployeesShape"

const TotalEmployeesSummaryShape = {
  totalEmployeesYears: PropTypes.arrayOf(PropTypes.shape(TotalEmployeesShape)),
}

export default TotalEmployeesSummaryShape



// WEBPACK FOOTER //
// ./src/state/shapes/TotalEmployeesSummaryShape.js